exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav{width:100%;position:absolute;top:100%;left:0;z-index:1;transform:translateX(-100%);transition:transform .2s linear}.nav.show{transform:translateX(0)}.nav__item{display:block;padding:1rem 0 1rem 5rem;background-color:#21282d;font-size:1.2rem;font-weight:700;color:#fff;text-transform:uppercase;text-decoration:none;transition:background .1s linear}.nav__item:hover{background-color:#2c353c}@media (max-width:1199px){.nav__item{font-size:1rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74f79736","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Nav.vue
// module id = 33
// module chunks = 0